export const ruleFieldId = 'h_rowAdjustment';